import _ from "underscore";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";
const { arrayOf, shape, string, number, node } = PropTypes;

export default class Breadcrumbs extends React.Component {
  static displayName = "Breadcrumbs";

  static propTypes = {
    items: arrayOf(
      shape({
        id: number,
        label: node,
        link: string,
      })
    ),
  };

  render() {
    const last_index = _.size(this.props.items) - 1;

    return (
      <div className="et--breadcrumbs">
        {_.map(this.props.items, (item, index) => (
          <span className="et--breadcrumbs--item" key={item.id}>
            {item.link ? (
              <a href={item.link} className="et--breadcrumbs--link">
                {item.label}
              </a>
            ) : (
              <span className="et--breadcrumbs--text">{item.label}</span>
            )}
            {index !== last_index ? <span className="et--breadcrumbs--seperator"> / </span> : undefined}
          </span>
        ))}
      </div>
    );
  }
}
